<template>
	<transition name="slide-fade">
		<div class="page home">
			<p>Robot D is Adam Drobotij, a web developer with 15 years of experience interpreting great designs and
				making them shine on the interactive page. He is skilled with many modern web programming
				languages (Javascript, <span class="smallcaps">HTML5</span>, <span class="smallcaps">CSS3</span> and a
				few <span class="smallcaps">CSS</span>-processors like <span class="smallcaps">SASS</span> and
				Post-<span class="smallcaps">CSS</span>,
				<span class="smallcaps">LAMP</span>, various front-end frameworks like
				<a href="https://facebook.github.io/react/">React</a>,
				<a href="http://angularjs.org/">Angular</a> and <a href="https://jquery.com/">JQuery</a>) but Adam&rsquo;s
				expertise lies in applying his art and animation education to the site-building process; resulting in a
				slick, intuitive experience for the user.
				Learning new skills is always interesting to him. He built this site to learn
				<a href="https://vuejs.org/">VueJS</a> and refresh his memory
				of <a href="https://threejs.org">ThreeJS</a>.
				Lately, he&rsquo;s been playing with Graphics Shaders and&nbsp;<a href="https://unity3d.com/">Unity3D</a>.</p>

			<p>Adam would love to work with you. Connect with him on&nbsp;<a href="http://www.linkedin.com/in/adamdrobotij">LinkedIn</a>.</p>

			<p>Also, if you would just like to talk about video games, football or food… he&rsquo;s down for&nbsp;that.</p>
		</div>
	</transition>
</template>
<style lang="scss" scoped>
	.home {
		text-align: left;
	}
</style>
<script type="text/babel">
    export default{
        data(){
            return{
                msg:'hello vue'
            }
        },
        components:{}
    }
</script>



// WEBPACK FOOTER //
// Home.vue?6c1e424c